import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import router from '@/router';

const SESSION_KEY = 'USER_SESSIONS';
const ACTIVE_SESSION_KEY = 'ACTIVE_SESSION_KEY';

export interface IUserSession {
  userId: string;
  name: string;
  userName: string;
  deptName: string;
  token: string;
  refresh_token: string;
  expires_time: Date;
  userType?: string;
  openId: string;
}

export interface ISessionManager {
  activeSession: IUserSession | null;
  sessions: IUserSession[] | null;
}

/** 会话管理，多身份模拟 */
@Module({ dynamic: true, store, name: 'session', namespaced: true })
class Session extends VuexModule implements ISessionManager {
  activeSession!: IUserSession;
  sessions: IUserSession[] = [];

  /** 增加会话  */
  @Action({})
  public async addUserAsync(userSession: IUserSession) {
    SessionModule.ADD_USER(userSession);
  }

  @Mutation
  public ACTIVE_USER(userSession: IUserSession) {
    this.activeSession = userSession;
    SessionModule.ADD_USER(userSession);
    localStorage.setItem(ACTIVE_SESSION_KEY, JSON.stringify(this.activeSession));
    //router.go(0);
  }

  /** 增加会话 */
  @Mutation
  public ADD_USER(userSession: IUserSession) {
    if (this.sessions && this.sessions.some(o => o.userName === userSession.userName)) {
      this.sessions = this.sessions.filter(v => v.userName != userSession.userName);
    }

    if (this.activeSession == null) {
      this.activeSession = userSession;
      this.sessions = [];
    }

    this.sessions!.push(userSession);

    localStorage.setItem(SESSION_KEY, JSON.stringify(this.sessions));
    localStorage.setItem(ACTIVE_SESSION_KEY, JSON.stringify(this.activeSession));
  }

  /** 移除会话 */
  @Mutation
  public REMOVE_USER(userSession: IUserSession) {
    const index = this.sessions!.indexOf(userSession);
    if (index >= 0) {
      this.sessions!.splice(index, 1);
    }

    localStorage.setItem(SESSION_KEY, JSON.stringify(this.sessions));
  }

  /** 初始化会话，从sessionStorage加载 */
  @Mutation
  public INIT() {
    const val = localStorage.getItem(ACTIVE_SESSION_KEY);
    if (val) {
      this.activeSession = JSON.parse(val);
      this.sessions = JSON.parse(localStorage.getItem(SESSION_KEY)!);
      console.log('vuex Session INIT  done, activeSession :', this.activeSession!.userName);
    }
    console.log('vuex Session INIT  done activeSession isnull ');
  }

  /** 清除所有会话 */
  @Mutation
  public CLEAR() {
    this.activeSession = null as any;
    this.sessions = [];

    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(ACTIVE_SESSION_KEY);
  }

  get getActiveSession() {
    console.log('session.getActiveSession', this.activeSession);
    return this.activeSession;
  }
}
const SessionModule = getModule(Session);
export default SessionModule;
